
import { defineComponent, PropType } from 'vue'
import { checkCardNumber } from '@entities/scannerCard'
import { useThemeModel } from '@entities/theme'
import { getScannerData } from '@entities/scanner'
import { AppButton } from '@shared/ui'

interface ISquare {
  x: string
  y: string
  w: string
  h: string
}

interface IData {
  width: number
  height: number
  requestCamera: boolean
  scanning: boolean
  disabledButton: boolean
  resData: string
  square: ISquare
  failedRecognize: boolean
  counter: number
  middlewareData: string[]
  activeModalLupa: boolean
  timer: number
}

interface CustomWindow extends Window {
  constraints?: MediaStreamConstraints;
}
export default defineComponent({
  name: 'VScannerCard',

  components: { AppButton },

  props: {
    scanner: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  },
  emits: ['onScanner', 'toggleApplyDiscount', 'onNumberCardScanner'],

  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  },

  data (): IData {
    return {
      // preloader: false,
      width: 0,
      height: 0,
      requestCamera: false,
      scanning: false,
      disabledButton: false,
      resData: '',
      square: { x: '0', y: '0', w: '0', h: '0' },
      failedRecognize: false,
      counter: 0,
      middlewareData: [],
      activeModalLupa: false,
      timer: 0
    }
  },
  watch: {
    counter () {
      if (this.counter === 3) {
        const cardNumer = checkCardNumber(this.middlewareData)
        this.activeModalLupa = false
        this.updateData(cardNumer)
      }
    }
  },
  async mounted () {
    await this.createCameraElement()
    this.width = Math.min(window.innerWidth * 2, 1080)
  },
  methods: {
    createCameraElement (): void {
      const customWindow: CustomWindow = window
      const constraints = (customWindow.constraints = {
        audio: false,
        video: {
          facingMode: 'environment',
          width: 1024,
          height: 768
        }
      })
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          const videoElement = this.$refs.camera as HTMLVideoElement
          if (videoElement) {
            videoElement.srcObject = stream
          }
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
          alert('Нет поддержки в вашем браузере')
        })
    },

    removeCameraElement (): void {
      const videoElement = this.$refs.camera as HTMLVideoElement | undefined
      if (videoElement && videoElement.srcObject instanceof MediaStream) {
        const tracks = videoElement.srcObject.getTracks()

        tracks.forEach(function (track: MediaStreamTrack) {
          track.stop()
        })
      }
      // this.$refs.camera.srcObject.getTracks().forEach(function (track) {
      //   track.stop()
      // })
    },

    drawSVG (): ISquare {
      const width = 0.9 * this.width
      const height = width * 54 / 86

      const svgns = 'http://www.w3.org/2000/svg'
      const rect = document.createElementNS(svgns, 'rect')
      rect.setAttributeNS(null, 'x', String((this.width - width) / 2))
      rect.setAttributeNS(null, 'y', String((this.height - height) / 2))
      rect.setAttributeNS(null, 'width', String(width))
      rect.setAttributeNS(null, 'height', String(height))

      return {
        x: String((this.width - width) / 2),
        y: String((this.height - height) / 2),
        w: String(width),
        h: String(height)
      }
    },

    takePhoto (): void {
      const context = (this.$refs.canvas as HTMLCanvasElement).getContext('2d')
      const photoFromVideo = this.$refs.camera as HTMLVideoElement | undefined
      this.square = this.drawSVG()
      if (context && photoFromVideo) {
        context.drawImage(photoFromVideo, 0, 0, this.width, this.height)
      }
    },

    downloadImage (): string {
      const canvas = document.getElementById('photoTaken') as HTMLCanvasElement
      if (canvas) {
        return canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
      } else {
        return ''
      }
    },

    dataURLtoFile (dataurl: string, filename: string): File | null {
      const arr = dataurl.split(',')
      const matchResult = arr[0].match(/:(.*?);/)
      if (matchResult && matchResult[1]) {
        const mime = matchResult[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      } else {
        return null
      }
    },

    updateData (cardNumber: string): void {
      this.resData = cardNumber
      if (this.resData.length === 9) {
        this.scanning = false
        this.disabledButton = true
        this.removeCameraElement()
        this.$emit('onNumberCardScanner', this.resData)
      } else {
        this.failedRecognize = true
        this.scanning = false
        this.disabledButton = true
        setTimeout(() => {
          this.failedRecognize = false
        }, 3000)
      }
    },

    async getData (): Promise<void> {
      await this.takePhoto()
      const src = this.downloadImage()
      const file = this.dataURLtoFile(src, 'image.jpeg')
      if (file) {
        const formData = new FormData()
        formData.append('image', file, 'image.jpeg')
        formData.append('x', this.square.x)
        formData.append('y', this.square.y)
        formData.append('h', this.square.h)
        formData.append('w', this.square.w)
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this
        getScannerData(formData)
          .then(function (res) {
            const numberCard = res.data.card_number
            if (numberCard.length) {
              self.middlewareData.push(numberCard)
            }
            self.counter++
          })
          .catch(function () {
            self.counter++
            self.activeModalLupa = false
            self.failedRecognize = true
            self.scanning = false
            self.disabledButton = true
            setTimeout(() => {
              self.failedRecognize = false
            }, 3000)
          })
      }
    },

    onScanner (): void {
      this.scanning = false
      this.removeCameraElement()
      this.$emit('onScanner')
    },

    toggleApplyDiscount (): void {
      this.$emit('toggleApplyDiscount')
    },

    onCamera (): void {
      const photoFromVideo = this.$refs.camera as HTMLVideoElement
      this.height = photoFromVideo.videoHeight / (photoFromVideo.videoWidth / this.width)
      this.requestCamera = true
      this.disabledButton = this.requestCamera
    },

    onScanning (): void {
      this.timer = Date.now()
      this.middlewareData = []
      this.counter = 0
      this.scanning = true
      this.disabledButton = false
      this.getData()
      setTimeout(() => {
        this.getData()
      }, 300)
      setTimeout(() => {
        this.getData()
      }, 600)
      setTimeout(() => {
        this.activeModalLupa = true
      }, 2500)
    }

  }
})
